import {
  beCampaignsBuilderGetArrayOfSourcesByIdList,
  beCampaignsBuilderGetEmailCampaignById,
  beCampaignsBuilderInsertEmailCampaign,
  beCampaignsBuilderUpdateEmailCampaign,
  beCampaignsSetArrayOfListsByIdSource
} from 'Api/beCampaign'
import {
  beContentInsertSource,
  beContentSourceGetListOfSources,
  beContentSourceGetSource,
  beContentUpdateContents
} from 'Api/beContentSource'
import {
  beEmailMessageApiCreateMessageThumbnail,
  beEmailMessageGetMessageLazyDetails
} from 'Api/beEmailMessageApi'
import { beFiltersGetFilter } from 'Api/beFiltersApi'
import { beRecipientGetGroupById } from 'Api/beRecipientApi'
import { beSendGoCheckSendingProgress } from 'Api/beSendApi'
import { beSendPostOnSend } from 'Api/beSendNWebApi'
import { storeGet, STORE_KEY_ID_LIST } from 'mailup-react-helpers'

export async function getEmailCampaignById(idCampaign) {
  const resp = await beCampaignsBuilderGetEmailCampaignById(idCampaign)
  return resp
}

export async function getListOfSources(param) {
  const resp = await beContentSourceGetListOfSources(param)
  return resp
}

export async function insertSource(data) {
  const resp = beContentInsertSource(data)
  return resp
}

export async function setArrayOfListsByIdSource(idSource, data) {
  const result = await beCampaignsSetArrayOfListsByIdSource(idSource, data)
  return result
}

export async function getArrayOfSourcesByIdList(idList) {
  const result = await beCampaignsBuilderGetArrayOfSourcesByIdList(idList)
  return result
}

export async function updateContents(idSource) {
  const resp = beContentUpdateContents(idSource)
  return resp
}

export async function insertEmailCampaign(data) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const resp = await beCampaignsBuilderInsertEmailCampaign(idList, data)

  return resp
}

export async function updateEmailCampaign(idCampaign, data) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const resp = await beCampaignsBuilderUpdateEmailCampaign(
    idList,
    idCampaign,
    data
  )

  return resp
}

export async function isSendingMessage(idMessage) {
  const { Value } = await beSendGoCheckSendingProgress(idMessage)
  return Value
}

export const getSourceBySourceId = async (idSource) => {
  const result = await beContentSourceGetSource(idSource)

  return result
    ? { sourceName: result.SourceName, sourceType: result.SourceType }
    : { sourceName: '', sourceType: null }
}

export const getGroupsNamesByGroupsIds = async (groupsIds) => {
  if (groupsIds) {
    const filteredGroups = groupsIds.filter((elem) => elem !== 0)
    const calls = filteredGroups.map((id) => beRecipientGetGroupById(id))
    const result = await Promise.all(calls)

    const labels = result.map(({ Id, Name }) => `ID ${Id} - ${Name}`)

    return labels
  }
  return []
}

export const getFiltersNamesByFilterId = async (filtersIds) => {
  if (filtersIds) {
    const filteredFilters = filtersIds.filter((elem) => elem !== 0)
    const calls = filteredFilters.map((id) => beFiltersGetFilter(id))
    const result = await Promise.all(calls)

    const Items = result.map(({ Id, Name, Description, Type }) => ({
      id: Id,
      name: Name,
      description: Description,
      type: Type
    }))

    return Items
  }
  return []
}

export const getMessageById = async (idMsg) => {
  const result = await beEmailMessageGetMessageLazyDetails(idMsg)

  return result ? result.HasThumbnail : false
}

export const getMessageThumbnail = async (idMessage) => {
  const result = await beEmailMessageApiCreateMessageThumbnail(idMessage)
  return result
}

export const checkIsOnSend = async (idMessage) => {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const params = { IdMessages: [idMessage], Completed: false, Started: true }
  const result = await beSendPostOnSend(idList, params)

  if (result) {
    const { Items: items } = result

    return items.length > 0
      ? items[0].Sent > 0 && items[0].Completed === false
      : false
  }
  return false
}
